<template>
    <div class="big-button flex-center-center flex-col" @click="$emit('button-click')">
        <button :aria-label="ariaLabel || alt || title" :aria-describedby="ariaDescribedBy" class="big-button__button bg--white">
            <img :src="icon" :alt="alt || title" >
        </button>

        <div class="big-button__text-wrap" id="title">
            <h2 class="h3">
                {{ title }}
            </h2>

            <!-- <p v-if="description" class="big-button__text">{{ description }}</p> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BigButton',
        props: {
            icon: {
                type: String,
                required: true
            },
            title: {
                type: String,
                default: null
            },
            alt: {
                type: String,
                default: null
            },
            description: {
                type: [String, Boolean],
                default: false
            },
            ariaLabel: {
                type: String,
                default: ''
            },
            ariaDescribedBy: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped lang="scss">
    .big-button__button {
        width: 120px;
        height: 80px;
        margin: 0 auto 0.75em;
        border-radius: 5px;
        color: #000;
        font-size: 18px;
        border: none;
        cursor: pointer;
        box-shadow: 4px 2px 4px 1px rgb(208, 208, 208);

        &:focus {
            box-shadow: 0 0.1em 0.5em rgba(0, 0, 0, 0.5);
        }

        img {
            max-height: 60px;
        }
    }

    // .big-button__text {
    //     font-size: 14px;
    // }

    .big-button--rev {
        flex-direction: column-reverse;

        .big-button__text {
            margin-bottom: 15px;

            @media screen and (min-width: 768px) {
                margin-bottom: 25px;
            }
        }
    }
</style>

